<template>
  <a-modal :title="null" :centered="true" :mask-closable="false" :closable="false" :footer="null" :visible="visible" :width="800" :body-style="{'padding':'0px', 'borderRadius':'4px'}">
    <div style="width: 100%;height: 54px;text-align: center;background: rgba(99, 171, 205, 0.06);border: 1px solid #E4E7EA;border-top-right-radius: 4px; border-top-left-radius:4px;">
      <span style="font-size: 18px;line-height:54px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #525252;">方剂详情</span>
      <a-button type="link" style="position: absolute; right: 24px; line-height: 56px;" @click="cancelAction">X 关闭</a-button>
    </div>
    <a-row class="custom-detail-row">
      <a-col :xxl="16" :xl="16" :lg="16" :md="24" :sm="24" :xs="24">
        <a-form-item label="方剂名" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
          <span  style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">{{ record.name }}</span>
        </a-form-item>
      </a-col>
      <a-col :xxl="8" :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
        <a-form-item label="证候" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 9, xl: 9, xxl: 9 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
          <span  style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">{{ (record.syndrome||'') }}</span>
        </a-form-item>
      </a-col>
      <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
        <a-form-item label="症状描述" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
          <span  style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">{{ record.symptom }}</span>
        </a-form-item>
      </a-col>
      <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
        <a-form-item label="处方" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
          {{ (record.drugs||[]).map(m => (m.name+' '+m.dosage+m.unit + (((m.usage||'') !='')?(','+m.usage):''))).join('、') }}
        </a-form-item>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
export default {
  name: "OwnPresDetail",
  data(){
    return {
      visible:false,
      record:{}
    }
  },
  methods:{
    showModal:function (id) {
      const self = this;
      this.$axios.get('/api/clinic/own/pres/'+id).then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz) {
          self.record =res.biz;
          self.visible = true;
        }
      }, function (res) {
      });
    },
    cancelAction:function (){
      this.visible = false;
    }
  }
}
</script>

<style scoped>
.gpws-m-b-10 {
  margin-bottom: 10px!important;
}
.custom-detail-row{
  padding-left: 16px;
  box-sizing: border-box;
}
</style>